// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:27:51

export default {
  "id": "doggo-jump",
  "slug": "doggo-jump",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a3d5b57dc36a4199be110c2a5b6e14dd-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a3d5b57dc36a4199be110c2a5b6e14dd/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Doggo Jump",
      "description": "\"Doggo Jump\" is a charming hyper-casual platform game where players controls a playful puppy as it hops between platforms, collecting bones and racking up points. With simple tap-to-jump mechanics, colorful graphics, and an adorable dog character, the game is easy to pick up and addictive, making it perfect for quick gaming sessions.",
      "instructions": "Tap anywhere to make the Doggo fall faster",
      "genres": [
        "Casual"
      ],
      "tags": [
        "1player",
        "arcade",
        "jumping",
        "platformer",
        "runner"
      ]
    },
    "zh-CN": {
      "title": "狗狗跳",
      "description": "“狗跳”是一款迷人的超休闲平台游戏，玩家控制一只顽皮的狗跳跃在不同平台上，收集骨头并积累分数。游戏拥有简单的点击跳跃机制、五彩斑斓的图形和可爱的小狗角色，上手容易且上瘾，非常适合短暂的游玩。",
      "instructions": "点击任何地方使Doggo掉落更快",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1玩家",
        "街机",
        "跳跃",
        "平台游戏",
        "跑酷"
      ]
    },
    "zh-TW": {
      "title": "狗狗跳",
      "description": "\"Doggo Jump\" 是一款迷人的超休闲平台遊戲，玩家控制一隻活潑的小狗在平台間跳躍，收集骨頭並積分。遊戲操作簡單，只需點擊跳躍，並配有豐富的圖像和可愛的狗角色，遊戲易於上手且上癮，是短時間遊戲的最佳選擇。",
      "instructions": "輕觸任何處使狗狗跌落更快",
      "genres": [
        "休闲"
      ],
      "tags": [
        "1 玩家",
        "街機",
        "跳躍",
        "平台遊戲",
        "跑酷遊戲"
      ]
    },
    "zh-HK": {
      "title": "狗狗跳",
      "description": "「Doggo Jump」是一款迷人的超簡單平台遊戲，玩家操控一隻活潑的小狗，從一個平台跳到另一個平台，收集骨頭並累積分數。遊戲採用簡單的點擊跳躍機制、多采多姿的圖像，以及可愛的小狗角色，易於上手且上癮，讓它成為短時間遊戲的完美選擇。",
      "instructions": "點擊任何地方使 Doggo 落得更快",
      "genres": [
        "隨意"
      ],
      "tags": [
        "1人遊玩",
        "街機",
        "跳躍",
        "平台",
        "跑酷"
      ]
    },
    "ja": {
      "title": "ドッグジョンプ",
      "description": "「Doggo Jump」は、楽しいハイパーカジュアルプラットフォームゲームで、プレイヤーは遊び心を持つワンコを操作し、プラットフォームを飛び越えながら骨を集め、ポイントを獲得します。シンプルなタップジャンプ操作、カラフルなグラフィック、そして可愛い犬のキャラクターで、簡単に始められ、飽きの来ないゲームは、短いゲームセッションに最適です。",
      "instructions": "どこかをタップしてDoggoを速く落ちさせる",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "1プレイヤー",
        "アーケード",
        "ジャンプ",
        "プラットフォーム",
        "ランナー"
      ]
    },
    "ko": {
      "title": "도그고 점프",
      "description": "\"Doggo Jump\"는 플레이어가 신나는 개를 조종하여 다양한 플랫폼을 건너며 뼈를 모으고 점수를 쌓는 매력적인 하이퍼캐주얼 플랫폼 게임입니다. 간단한 탭하여 점프하는 메커니즘, 풍부한 그래픽, 그리고 귀염둥이 개 캐릭터로 인해 쉽게 플레이할 수 있으며 중독성이 높아 짧은 게임 시간에도 최적입니다.",
      "instructions": "어디든 탭하여 Doggo가 더 빨리 떨어져라",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "1플레이어",
        "아케이드",
        "점프",
        "플랫폼 게임",
        "러너"
      ]
    },
    "fr": {
      "title": "Chien qui Saut",
      "description": "\"Doggo Jump\" est un charmant jeu hyper-casual de plateformes où les joueurs contrôlent un chiot jouet qui bondit d'une plateforme à l'autre, ramassant des os et accumulant des points. Avec une mécanique de saut simple au clic et des graphismes colorés, ainsi qu'un personnage adorable de chien, le jeu est facile à prendre en main et addictif, ce qui le rend parfait pour des sessions de jeu rapides.",
      "instructions": "Tapez n'importe où pour faire tomber le Doggo plus vite",
      "genres": [
        "Occasionnel"
      ],
      "tags": [
        "1 joueur",
        "arcade",
        "saut",
        "plate-forme,runner"
      ]
    }
  }
};
